import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import logo from "../assets/logo.png"; // ajuste se estiver em outro caminho

export const exportarAlunos = (
  alunos,
  formato,
  titulo = "Pré-Registo de Aluno",
  nomeArquivoBase = "alunos_exportados",
  nomeEscola = "Escola Vida Abundante"
) => {
  if (!alunos || alunos.length === 0) {
    alert("Nenhum dado para exportar.");
    return;
  }

  const nomeArquivo = `${nomeArquivoBase}_${new Date().toISOString().slice(0, 10)}`;

  const colunas = [
    "Código do Aluno",
    "Nome",
    "Classe",
    "Turma",
    "Gênero",
    "Status",
    "Data da Matrícula"
  ];

  // Normaliza os dados para exportação
  const dadosNormalizados = alunos.map((aluno) => {
    const normalizar = (valor) => (valor && valor.toString().trim() !== "" ? valor : "—");

    return {
      "Código do Aluno": normalizar(
    aluno.codigo_aluno ?? aluno["Código do Aluno"] ?? aluno.codigo ?? aluno.id
  ),
  "Nome": normalizar(
    aluno.nome_completo ?? aluno.nome ?? aluno["Nome"]
  ),
  "Classe": normalizar(
    aluno.classe ?? aluno["Classe"] ?? aluno.ano
  ),
  "Turma": normalizar(
    aluno.turma ?? aluno["Turma"] ?? "—"
  ), // <-- Adicionado aqui
  "Gênero": normalizar(
    aluno.genero ?? aluno["Gênero"] ?? aluno.sexo ?? aluno["Sexo"]
  ),
  "Status": normalizar(
    aluno.status ?? aluno["Status"] ?? (aluno.ativo ? "Ativo" : "Inativo")
  ),
  "Data da Matrícula": normalizar(
    aluno.data_matricula ??
    aluno["Data da Matrícula"] ??
    aluno.data_registo ??
    aluno["Data de Registo"] ??
    aluno.registro_em
      ),
    };
  });

  if (formato === "pdf") {
    const doc = new jsPDF("landscape");
    const img = new Image();
    img.src = logo;

    img.onload = () => {
      const imgWidth = 40;
      const aspectRatio = img.height / img.width;
      const imgHeight = imgWidth * aspectRatio;

      doc.addImage(img, "PNG", 10, 10, imgWidth, imgHeight);

      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text(`ACADE - ${titulo}`, 60, 20);

      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");
      doc.text(`${nomeEscola}`, 60, 30);

      autoTable(doc, {
        head: [colunas],
        body: dadosNormalizados.map((aluno) => colunas.map((campo) => aluno[campo])),
        startY: 45,
        styles: {
          fontSize: 11,
          cellPadding: 3,
        },
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: 255,
          halign: "center",
        },
        margin: { top: 10 },
      });

      doc.save(`${nomeArquivo}.pdf`);
    };
  } else if (formato === "excel") {
    const dadosExcel = dadosNormalizados.map((aluno) =>
      colunas.reduce((acc, campo) => {
        acc[campo] = aluno[campo];
        return acc;
      }, {})
    );

    const ws = XLSX.utils.json_to_sheet(dadosExcel);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Alunos");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, `${nomeArquivo}.xlsx`);
  } else if (formato === "csv") {
    const csvLinhas = dadosNormalizados.map((aluno) =>
      colunas.map((campo) => `"${aluno[campo]}"`).join(",")
    );
    const csvContent = `${colunas.join(",")}\n${csvLinhas.join("\n")}`;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `${nomeArquivo}.csv`);
  } else {
    alert("Formato de exportação não suportado.");
  }
};
